import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.hasTypeMismatch ? _c(VTooltip, {
    attrs: {
      "right": "",
      "max-width": "300",
      "content-class": "type-mismatch-tooltip"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function ({
        on,
        attrs
      }) {
        return [_c(VIcon, _vm._g(_vm._b({
          class: _vm.iconClass,
          attrs: {
            "small": "",
            "color": "warning"
          }
        }, 'v-icon', attrs, false), on), [_vm._v("fal fa-exclamation-triangle")])];
      }
    }], null, false, 1352599003)
  }, [_c('span', [_vm._v(_vm._s(_vm.tooltipMessage))])]) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };